import { React, UseState, UseEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'layouts/PageContent';
import ExecutiveOrderTrend from './ExecutiveOrderTrend';

const ExecutiveOrderTrendScreen = (props) => {
  const {t, i18n} = useTranslation(['salesPerformance', 'common']);
  
  return (
    <PageContent title={t('salesPerformance:ExecutiveOrderTrend')}>
      <ExecutiveOrderTrend />
    </PageContent>
  )
}

export default ExecutiveOrderTrendScreen;